import { Link } from "react-router-dom";
import { Seo } from "@/components/site/Seo";
import { RuneMark } from "@/components/site/Img";

export default function NotFound() {
  return (
    <section className="container-x relative flex min-h-[70vh] flex-col items-start justify-center py-24" data-testid="not-found-page">
      <Seo path="/404" fallbackTitle="Page not found | Jorvik Tuning" noindex />
      <div className="knot-bg pointer-events-none absolute inset-0 opacity-[0.03]" />
      <RuneMark className="mb-8 h-14 w-14 text-[color:var(--bronze)]" />
      <p className="eyebrow">Error 404</p>
      <h1 className="mt-4 font-display text-5xl font-bold uppercase sm:text-6xl">Page not found</h1>
      <p className="mt-5 max-w-lg text-slate-400">That page doesn't exist or has moved. Our site was rebuilt recently — try one of these instead.</p>
      <div className="mt-10 flex flex-wrap gap-3">
        <Link to="/" className="btn-ice" data-testid="not-found-home">Home</Link>
        <Link to="/shop" className="btn-ghost" data-testid="not-found-shop">Shop</Link>
        <Link to="/tuning-tools" className="btn-ghost">Tuning tools</Link>
        <Link to="/contact" className="btn-ghost">Contact</Link>
      </div>
    </section>
  );
}
